module.exports = __webpack_public_path__ + "img/ddos.e3fe46f.svg";